<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import BtnModul from "@/components/btn-module.vue";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";  
//import store from "@/state/store"; 

import 'xdlocalstorage-separately'
export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Hoşgeldiniz",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    BtnModul,
  },
  data() {
    return {
      title: this.$t("welcome.Title"),
      items: [
        {
          text: this.$t("welcome.Title"),
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Uygulamalar: {}, 
      FilterUygulamaadi:"",
      RoleGroups:null
    };
  },
  mounted() {  
   
      this.ActionsFilterGet({
        Service:
          this.$config.API_ACCOUNT_URL + "Account/get-userroles",
          Page: this.Page,
          Filter: "&email="+this.UserEmail,
      }).then((res) => {
        if(res.Succeeded){
        this.RoleGroups = res.Data.RoleGroups;
        }
        
      });

  },
  methods: {
   async Get() {
  try {
    const res = await this.ActionsFilterGet({
      Service: "ouygulama",
      Page: this.Page,
      Filter: "&Uygulamaadi=" + this.FilterUygulamaadi,
    });

    this.Uygulamalar = res.Data;
    this.Page.PageDataSize = res.TotalCount;

  } catch (error) {
    console.error("Veri alınırken hata oluştu:", error);
  }
}
,  
    UygulamaYetkiSorgu(Uygulamaadi){ 

      let UygulamaSorgu = this.RoleGroups.filter(function(Role) {
        return Role == Uygulamaadi;
      });  
      if(UygulamaSorgu.length != 0) return true
      else return false  
    }, 

    MuneRolesControl() {  
      let YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("SuperAdmin")
      );
      if (YetkiSorgu.length != 0) return true
      else return false  
    },
  },
  created(){ 
   }
};
</script>

<template>

  <Layout @uygulamaarama="(FilterUygulamaadi = $event),Get()"> 
 
    <div class="container">  <div style="word-break: break-all;">    </div>
      <div class="py-2">
        <h1 class="card-title">{{ $t("welcome.page.uygulamalar") }}</h1>
        <p class="card-title-desc"></p>
      </div>  
      <div class="row text-center justify-content-center"  > ,
         
        <template v-for="(Uygulama, index) in Uygulamalar">
       <btnModul
        :key="index"
        v-if="UygulamaYetkiSorgu(Uygulama.Uygulamaadi) || MuneRolesControl()"
        :link="Uygulama.Link + '/' "
        :title="Uygulama.Uygulamaadi === 'Strateji Bilgi Sistemi' 
                    ? 'Strateji & Kalite Bilgi Sistemi' 
                    : Uygulama.Uygulamaadi"
        :icon="Uygulama.Resimadresi"
        notifi=""
      />,
      </template>
      </div>
    </div>
    <hr />
    <!--
          <div class="container">
            <div class="py-2">
                <h1 class="card-title">KİŞİSEL MENÜM</h1>
                <p class="card-title-desc"></p>
              </div>
            <div class="row text-center justify-content-center">
              <btnModul link="a" title="Vakıf Geliştirme Modülü" icon="fa-paper-plane" notifi=""/>
              <btnModul link="a" title="Hasan Amcanın Tarağı" icon="fa-assistive-listening-systems" notifi="33"/>
              <btnModul link="a" title="Böyle Gelmiş Böyle Gecer Dünya Bu Nasıl Dünya" icon="fa-american-sign-language-interpreting" notifi="3"/>
              <btnModul link="a" title="Bu Nasıl Dünya" icon="fa-rocket" notifi=""/>
              <btnModul link="a" title="Vakıf Geliştirme Modülü" icon="fa-paper-plane" notifi=""/>
              <btnModul link="a" title="Böyle Gelmiş Böyle Gecer Dünya Bu Nasıl Dünya" icon="fa-american-sign-language-interpreting" notifi="3"/>
              <btnModul link="a" title="Hasan Amcanın Tarağı" icon="fa-lungs" notifi="33"/>
              <btnModul link="a" title="Bu Nasıl Dünya" icon="fa-rocket" notifi=""/>
            </div>
          </div>-->
  </Layout>
</template>
